import React from "react";
import { NavLink, Outlet, useNavigate, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export default function AdminLayout() {
  const { user, loading, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  if (loading) return null;
  if (!user) {
    return <Navigate to="/admin/login" state={{ from: loc.pathname }} replace />;
  }

  const onLogout = () => {
    logout();
    nav("/admin/login", { replace: true });
  };

  return (
    <div className="admin-shell">
      <aside className="admin-side">
        <div className="brand">
          <span className="dot" />
          Studio
        </div>

        <nav className="admin-nav" aria-label="Admin navigation">
          <NavLink to="/admin" end>Posts</NavLink>
          <NavLink to="/admin/new">New post</NavLink>
          <NavLink to="/admin/projects">Projects</NavLink>
          <NavLink to="/admin/shopify">Shopify</NavLink>
          <NavLink to="/admin/stack">Tech stack</NavLink>
          <NavLink to="/admin/resume">Resume</NavLink>
          <NavLink to="/blog" target="_blank" rel="noreferrer">View blog ↗</NavLink>
          <NavLink to="/" target="_blank" rel="noreferrer">View site ↗</NavLink>
        </nav>

        <div className="who">
          Signed in as <strong style={{ color: "var(--text)" }}>{user.username}</strong>
          <button type="button" onClick={onLogout}>Sign out</button>
        </div>
      </aside>

      <main className="admin-main">
        <Outlet />
      </main>
    </div>
  );
}
